import { Carousel, Collapse } from "antd"
import { CarouselRef } from "antd/es/carousel";
import { useEffect, useState } from "react";
import './index.less'

const { Panel } = Collapse;
let domCarousel: any = null
export const Banner = ({data, type}: {data: {
    title: string,
    content: any,
    url: string
}[],type:string}) => {

    const [activeKey, setActiveKey] = useState<string | string[]>('0')
    const [targetDom, setTargetDom] = useState<CarouselRef>()
    const handleChange = (val:string | string[]) => {
        // if (domCarousel && typeof(val) === 'string') {
        //     domCarousel.goTo(val,true)
        // }
        setActiveKey(val)
        // domCarousel.goTo(val,true)
    }
    const handleBeforeChange = (from:any, to:any) => {
        setActiveKey(to)
    }

    // const refFun = (dom: CarouselRef) => {
    //     dom && (domCarousel = dom)
    // }
    useEffect(() => {
        domCarousel.goTo(activeKey)
    }, [domCarousel])
    return type === '1' ? <div className="banner-col-container">
    <Collapse className="collapse-wrapper" accordion activeKey={activeKey} ghost onChange={handleChange}>
    {data.map((item, index) => 
        <Panel showArrow={false} header={item.title} key={index}>
            <p>{item.content}</p>
        </Panel>)}
    </Collapse>
    <div className="carousel-wrapper">
        <Carousel ref={(dom:CarouselRef) => { dom&&(domCarousel = dom) }} autoplay effect="fade" dots={false} beforeChange={handleBeforeChange}>
        {data.map((item, index) => 
            <div key={index}>
                <img src={item.url} alt="" />
            </div>)}
        </Carousel>
    </div>
</div> : <div className="banner-col-container right-content">
        <Collapse className="collapse-wrapper" accordion activeKey={activeKey} ghost onChange={handleChange}>
        {data.map((item, index) => 
            <Panel showArrow={false} header={item.title} key={index}>
                <p>{item.content}</p>
            </Panel>)}
        </Collapse>
        <div className="carousel-wrapper" >
            <Carousel  ref={(dom:CarouselRef) => { dom&&(domCarousel = dom) }} autoplay effect="fade" dots={false} beforeChange={handleBeforeChange}>
            {data.map((item, index) => 
                <div key={index} className={type==='2'? "carousel-item" : ''}>
                    <img className={index+''==activeKey&&index===2&&type==='2'?'img-rotate' : type==='2'&&index===1&&activeKey=='1' ? 'img-rotate-2': ''} src={item.url} alt="" />
                    {index===1&&type==='2' && <img className='img-bottom' src='https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16703076357901955.png' alt="" />}
                </div>)}
            </Carousel>
        </div>
    </div>
}